import {
  compareField,
  compareSimpleField,
  compareSingleHmoField,
  compareTierField,
} from "./CompareField.component";

const comFullArrayEquality = (plans: any) => [
  {
    name: "overview",
    childrens: [
      {
        name: "Monthly Premium",
        equal: compareSimpleField(plans, "MonthlyPremiumAmount"),
      },
      {
        name: "Deductible",
        equal: true,
      },
      {
        name: "Maximum Out-of-Pocket",
        equal: compareSimpleField(plans, "OutOfPocketMaxInNetworkAmount"),
      },
      {
        name: "Part B Rebate",
        equal: true,
      },
    ],
  },
  {
    name: "doctors",
    childrens: [
      {
        name: "PCP Copay",
        equal: compareSimpleField(plans, "PCPCopayInNetworkAmount"),
      },
      {
        name: "Specialist Copay",
        equal: compareSimpleField(plans, "SpecialistCopayInNetworkAmount"),
      },
    ],
  },
  {
    name: "hospital",
    childrens: [
      {
        name: "Inpatient Hospital - Acute",
        equal: compareField(
          "Inpatient Hospital",
          "Inpatient Hospital Acute",
          plans
        ),
      },
      {
        name: "Outpatient Hospital & Observation",
        equal: compareSingleHmoField(
          "Emergency Care/ Post-Stabilization Care",
          plans
        ),
      },
      {
        name: "Emergency Care",
        equal: compareSingleHmoField(
          "Emergency Care/ Post-Stabilization Care",
          plans
        ),
      },
      {
        name: "Ground & Air Ambulance",
        equal: compareSingleHmoField(
          "Ground and Air Ambulance Services",
          plans
        ),
      },
      {
        name: "Skilled Nursing (SNF)",
        equal: compareSingleHmoField("Skilled Nursing Facility", plans),
      },
    ],
  },
  {
    name: "dental",
    childrens: [
      {
        name: "Preventative (Routine)",
        equal: compareField(
          "Dental Services",
          "Preventive Dental (Routine)",
          plans
        ),
      },
      {
        name: "Comprehensive",
        equal: compareField("Dental Services", "Comprehensive Dental", plans),
      },
    ],
  },
  {
    name: "vision",
    childrens: [
      {
        name: "Eye Exams",
        equal: compareField(
          "Vision Services",
          "Eye Exams (Medicare and Routine)",
          plans
        ),
      },
      {
        name: "Eyewear",
        equal: compareField("Vision Services", "Eyewear", plans),
      },
    ],
  },
  {
    name: "prescriptions",
    childrens: [
      {
        name: "Part D Deductible",
        equal: compareField(
          "Part D Deductible",
          "Part D Deductible in network standard medicare-defined",
          plans
        ),
      },
      {
        name: "Initial Coverage Limit",
        equal: compareSingleHmoField("Initial Coverage Limit", plans),
      },
      {
        name: "Part D Out-of-Pocket Threshold",
        equal: compareSingleHmoField("Part D Out-of-Pocket Threshold", plans),
      },
    ],
  },
  {
    name: "prescriptions-tiers",
    childrens: [
      {
        name: "Tier 1: Preferred Generic",
        equal: compareTierField("Preferred Generic Drugs", plans),
      },
      {
        name: "Tier 2: Generic",
        equal: compareTierField("Generic Drugs", plans),
      },
      {
        name: "Tier 3: Preferred Brand",
        equal: compareTierField("Preferred Brand Drugs", plans),
      },
      {
        name: "Tier 4: Non-Preferred",
        equal: compareTierField("Non-Preferred Brand Drugs", plans),
      },
      {
        name: "Tier 5: Specialty Tier",
        equal: compareTierField("Specialty Tier Drugs", plans),
      },
      {
        name: "Tier 6: Select Care",
        equal: compareTierField("Select Care Drugs", plans),
      },
    ],
  },
  {
    name: "additional-benefits",
    childrens: [
      { name: "24/7 Concierge Service", equal: true },
      {
        name: "Over-the-Counter (OTC) Allowance",
        equal: compareSingleHmoField("Over-The-Counter (OTC)", plans),
      },
      {
        name: "FLEX Allowance",
        equal: true,
      },
      {
        name: "Transportation",
        equal: true,
      },
      {
        name: "Caregiver Support",
        equal: compareSingleHmoField(
          "Support for Care Givers Of Enrollee",
          plans
        ),
      },
      {
        name: "Grocery SSBCI Eligible",
        equal: compareField(
          "SSBCI",
          "Special Supplemental Benefits for the Chronically Ill (SSBCI) Groceries Benefit",
          plans
        ),
      },
    ],
  },
];

export default comFullArrayEquality;
